import { FC } from "react";
import { Column, ColumnConfig } from "@ant-design/plots";
import { showInitialPartOfString } from "@pages/utils/utils";

const BarChart: FC<any> = (props) => {
  const data = props?.data ? props.data : [];

  const config:ColumnConfig = {
    data,
    xField: props?.xField,
    yField: props?.yField,
    columnWidthRatio: 0.3,
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: true,
        formatter: (label) => {
          return showInitialPartOfString(label, 10 )
        }
      },
    },
    meta: {
      cost:{
        formatter:(val:any)=> `$ ${val?.toFixed()}`
      }
    },
    // tooltip: {
    //   domStyles:{
    //     "g2-tooltip": {backgroundColor:"#091e42", color:"#fff", borderRadius:"8px"}
    //   }
    // },
  
  };
  return <Column {...config} />;
};

export default BarChart;
